import get from 'lodash/get';
import moment from 'moment';
import BaseModel from '../../common/models/base.model';

class Car extends BaseModel {
  schema = {
    vin: this.yup.string().length(17, 'Numer VIN musi składać się z 17 znaków').matches(/^[A-HJ-NPR-Z\d]{13}\d{4}/g, 'Numer VIN niepoprawny, powinien zawierać same cyfry lub duże litery bez I, O oraz Q'),
    manufacturer: this.yup.number().integer().required(this.requiredText),
    model: this.yup.number().integer().required(this.requiredText),
    fuelType: this.yup.number().integer().required(this.requiredText),
    engine: this.yup.number().integer().required(this.requiredText)
      .min(500, 'Mimalna pojemność to 500cm3')
      .max(8400, 'Maksymalna pojemność to 8400'),
    power: this.yup.number().integer().required(this.requiredText)
      .min(20, 'Mimalna moc to 20kW')
      .max(1500, 'Maksymalna moc to 1500kW'),
    mileage: this.yup.number().integer()
      .required(this.requiredText)
      .min(0, 'Przebieg musi się zawierać pomiędzy 0 a 1000000km')
      .max(1000000, 'Przebieg musi się zawierać pomiędzy 0 a 1000000km'),
    year: this.yup.number().integer().required(this.requiredText)
      .min(1990, 'Rok musi się zawierać pomiędzy 1990 a biezącym')
      .max(moment().format('YYYY'), 'Rok musi się zawierać pomiędzy 1990 a bieżącym'),
    notes: this.yup.string().max(2000, 'Za długa notatka'),
  }

  getData() {
    return {
      ...this.data,
      fuelType: get(this.data, 'fuelType.id'),
      model: get(this.data, 'model.id'),
      manufacturer: get(this.data, 'manufacturer.id'),
    };
  }
}

export default Car;
